import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"; // <-- import styles to be used
import { Link, useNavigate } from "react-router-dom";
import appsetting from "../../appsettings.json";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { setEmail, setMobile, setName, setRFToken, setRole, setToken, setUserAccess, setUsername } from "../../redux/user/userAction";
import { toast } from "react-toastify";
const Navbar = () => {
  const {token,rftoken,userAccess,role,name}=useSelector(state=>state.user)
//  تابع تغییر تم 
  let changetheme=()=>{
    if (document.documentElement.getAttribute('data-bs-theme')==='dark') {
      document.documentElement.setAttribute('data-bs-theme', 'light')
      setDarkTheme(false)
      localStorage.setItem('theme','light')
    } else {
      document.documentElement.setAttribute('data-bs-theme', 'dark')
      setDarkTheme(true)
      localStorage.setItem('theme','dark')

    }
  }
  const dispatch=useDispatch()
  const theme=localStorage.getItem("theme")
  const [darktheme,setDarkTheme] = useState(theme!==null?(theme==='dark'?true:false):false);

  
  const navigate = useNavigate();
  // تابع خروج از حساب کاربری
  const SignOut = () => {
    var dto = { token: rftoken };
    axios
      .post(`/api/user/signout`, dto)
      .then(function (response) {
        console.log(response);
        localStorage.clear()
        toast("خدا نگه دار", {type:'success'})
      window.location.href="/"
      })
      .catch(function (err) {
        console.log(err.response.data);
      });
       
  };
  return (
    <nav className="navbar navbar-expand-lg  bg-dark text-white">
    <div className="container-fluid d-md-flex justify-content-md-start">
      <a className="navbar-brand ml-auto" href="/">
        سامانه جامع IOT آویسان &nbsp; |{" "}
        <span style={{ color: "#fefefe" }}>
          {" "}
          سامانه توزیع برق تهران بزرگ
        </span>
      </a>
      {token && (
        <>
              <div className="dropdown">
                <button
                  className="nav-link active dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  aria-current="page"
                >
                  <FontAwesomeIcon icon={solid("user")} />
                </button>

                <ul className="dropdown-menu" dir="rtl">
                  <li>
                    <p>
                      {" "}
                      {name + " "}
                      <span
                        className="text-secondary"
                        style={{ fontSize: ".7em" }}
                      >
                        (
                        {role}
                        )
                      </span>
                    </p>

                    <hr />
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      style={{ textAlign: "right" }}
                      href="/profile"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={solid("user-circle")} />{" "}
                      پروفایل
                    </a>
                  </li>
                  {/*<li>
                      <a
                        className="dropdown-item"
                        style={{ textAlign: "right" }}
                        href="#!"
                      >
                        <FontAwesomeIcon icon={solid("cog")} /> تنظیمات
                      </a>
                    </li> */}

                  <li>
                    <button
                      className="dropdown-item btn-none"
                      style={{ textAlign: "right", padding: "4px 16px" }}
                      onClick={SignOut}
                    >
                      <FontAwesomeIcon icon={solid("sign-out")} /> خروج
                    </button>
                  </li>
                </ul>
              </div>
            
              <button
                className="btn-none mt-auto mb-auto me-1 p-2 text-white"
                style={{ fontSize: "1.1em" }}
                onClick={() => changetheme()}
              >
                {darktheme ? (
                  <>
                    <FontAwesomeIcon
                      className="text-white"
                      icon={solid("sun")}
                    />
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon
                      className="text-white  "
                      icon={solid("moon")}
                    />
                  </>
                )}
              </button>
          
        </>
      )}
    </div>
  </nav>
  );
};

export default Navbar;
